/*
  TMA — collapse the product info cards on a phone only.

  The cards ship as <details open>, so with no JavaScript, on any browser, they
  are all expanded: exactly the behaviour this replaces. Nothing here is
  load-bearing.

  Only the phone collapses them, and only two of the three. On desktop the
  cards sit in a row, so the row is as tall as its tallest open card and
  collapsing saves nothing — it just leaves stubs beside a tall neighbour. On a
  phone they stack, where it saves about 700px.

  "What's in it" carries data-keep-open because it answers "what else do I need
  to buy tonight?", which is a question that blocks the purchase. The other two
  are read after the pouch arrives.
*/
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var cards = document.querySelectorAll('.t26-facts__card');
  if (!cards.length) return;

  function apply() {
    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-keep-open')) return;
      /* Once someone has opened a card themselves, leave it alone. */
      if (card.hasAttribute('data-touched')) return;
      if (mq.matches) card.removeAttribute('open');
      else card.setAttribute('open', '');
    });
  }

  Array.prototype.forEach.call(cards, function (card) {
    card.addEventListener('toggle', function () {
      if (mq.matches) card.setAttribute('data-touched', '');
    });
  });

  apply();
  /* Resizing across the breakpoint must not strand a card closed on desktop,
     where the summary is not clickable. */
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
